import { DirectSalesMediaType, DirectSalesMediaTypeLabel } from 'components/common/types/DirectSalesCampaign.types';

export const mediaTypeDataOptions = Object.keys(DirectSalesMediaType).map((mediaTypeKey: DirectSalesMediaType) => ({
  code: DirectSalesMediaType[mediaTypeKey],
  name: DirectSalesMediaTypeLabel[mediaTypeKey],
}));
